import { render, staticRenderFns } from "./wallerstatistics.vue?vue&type=template&id=6ff4e0a1&scoped=true"
import script from "./wallerstatistics.vue?vue&type=script&lang=js"
export * from "./wallerstatistics.vue?vue&type=script&lang=js"
import style0 from "./wallerstatistics.vue?vue&type=style&index=0&id=6ff4e0a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff4e0a1",
  null
  
)

export default component.exports